module.exports = "<div class=\"content\">\n\n  <div class=\"checkbox pull-left\">\n    <input type=\"checkbox\" id=\"dontShowAgain\" ng-model=\"$ctrl.dontShowAgain\" ng-true-value=\"true\" ng-change=\"$ctrl.setDontShowAgain()\">\n    <label for=\"dontShowAgain\">\n      {{'GLOBALS.COACHMARK.DONTSHOWAGAIN' | translate }}\n    </label>\n  </div>\n\n  <label ng-if=\"False\" ng-click=\"$ctrl.ampInfo()\" class=\"amplify\">\n    {{'SOLIDARITY.MAIN.AMPLIFY_INFORMATION' | translate }}\n  </label>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidayEuroFooter/whatIsSolidayEuroFooter.html
// module id = 2266
// module chunks = 0